/* eslint-disable max-len */
module.exports = {
  /* ============== PRESENTATION =============== */
  presentation: {
    sections: [
      {
        id: "cover",
        datatransition: "slide",
        content: `<h2>Geocontrol-NN</h2>
            <h4>Laboratories complex for construction</h4><br>
            <p><small><a href='https://www.gc-nn.com'>GC-NN.COM</a></small></p>`
      },
      {
        id: "slidecontrols",
        datatransition: "slide-in fade-out",
        content: `
          <p style='font-size: 1.5rem;'>Before start</p>
          <h4>Presentation hotkeys:</h4>
          <ul style='font-size: 1.5rem; color: Beige;'>
            <li>F - Maximize to full screen (Esc - exit to normal mode)</li>
            <li>O - Show all slides thumbnails</li>
            <li>Click Logo <img class='rz-reset-all-styles' src='/img/general/gc-logo-w-48.png'> on the left-top screen corner - Return to the main site</li>
            <li>Select Presentation language using the buttons on the right-top screen corner RU/EN</li>
          </ul>
          `
      },
      {
        id: "intro01",
        databackground: "/img/presentation/surveying-01.jpg",
        datatransition: "slide-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <div class="txt-stroke-blue-shadow">
            <p>Founded in 2014, "Geocontrol-NN" company was mainly engaged in geodesy and mine surveying.</p>
            <p class="fragment fade-up">Since 2018, the non-destructive testing laboratory area of focus has received significant development,</p>
            <p class="fragment fade-up">and since 2019, "Geocontrol-NN" has a large base for mechanical testing and a construction laboratory.</p>
          </div>
            `
      },
      {
        id: "ndt01",
        databackground: "/img/presentation/ndt-01.jpg",
        datatransition: "fade-in fade-out",
        dataautoanimate: true,
        content: `
          <div class="txt-stroke-black-shadow" data-id="01" style="color:yellow;">The Non-Destructive-Testing laboratory is certified and accredited for a large number of methods:</div>
          <ul class="txt-stroke-black-shadow" data-id="02" style="font-size:0.6em; display:none; color:#FFFFCC; list-style-image:url(img/listmarkers/marker05.png)">
          </ul>
        `
      },
      {
        id: "ndt02",
        databackground: "/img/presentation/ndt-01.jpg",
        datatransition: "fade-in slide-out",
        dataautoanimate: true,
        content: `
          <div class="txt-stroke-black-shadow" data-id="01" style="">The Non-Destructive-Testing laboratory is certified and accredited for a large number of methods:</div>
          <ul class="txt-stroke-black-shadow" data-id="02" style="font-size:0.6em; color:#FFFFCC; list-style-image:url(img/listmarkers/marker05.png)">
            <li>Visual and measuring control</li>
            <li>Ultrasonic control (including Ultrasonic thickness measurement, ultrasonic hardness testing, ultrasonic testing for continuity)</li>
            <li>Radiographic control</li>
            <li>Inspection by penetrating substances (color flaw detection, chalk-kerosene)</li>
            <li>Inspection of welded seams by vacuum and overpressure</li>
            <li>Magnetic particle testing</li>
            <li>Thermal imaging control (building facades, individual parts, electrical appliances)</li>
            <li>Vibro-diagnostics</li>
            <li>Acoustic emission method</li>
            <li>X-ray fluorescent chemical analysis of metals and alloys</li>
            <li>Electro-monitoring of insulation / paint coatings of pipes for continuity</li>
          </ul>
        `
      },
      {
        id: "ndt03",
        databackground: "/img/presentation/ndt-02.jpg",
        datatransition: "slide",
        databackgroundtransition: "convex",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>Basic methods of any NDT laboratory - <span style="color:Wheat; font-weight:bold;">VT, RT, UT, DPI</span></p>
            <p class="fragment fade-up">In the «Geocontrol-NN» staff  - <span style="color:Wheat; font-weight:bold;">28</span> certified specialists in x-ray control method, of which <span style="color:Wheat; font-weight:bold;">8 employees</span> - also are specialists in ultrasonic testing</p>
            <p class="fragment fade-up">The work experience of most specialists is <br><span style="color:Wheat; font-weight:bold;">over 5 years</span></p>
          </div>
        `
      },
      {
        id: "ndt04",
        databackground: "/img/presentation/ndt-03.jpg",
        datatransition: "slide",
        databackgroundtransition: "convex",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>The laboratory is provided with a sufficient equipment amount:</p>
            <ul style="font-size:0.7em; list-style-image:url(img/listmarkers/marker05.png)">
              <li class="fragment fade-up"><span style="color:Wheat; font-weight:bold; font-size:1.2em;">11</span> impulse X-ray machines</li>
              <li class="fragment fade-up">constant radiation x-ray machines - <span style="color:Wheat; font-weight:bold;">RPD-200C, MART-200</span></li>
              <li class="fragment fade-up"><span style="color:Wheat; font-weight:bold; font-size:1.2em;">5</span> ultrasonic testers, incl. <span style="color:Wheat; font-weight:bold;">antenna-phased array devices</span></li>
              <li class="fragment fade-up"><span style="color:Wheat; font-weight:bold; font-size:1.2em;">2</span> acoustic emission devices <span style="color:Wheat;">MALAHIT A-LINE-32D</span> for 40 channels and 8 channels</li>
              <li class="fragment fade-up">equipment for vacuuming, electrical testing of insulation and paint coatings, portable thickness gauges and much more</li>
            </ul>
          </div>
        `
      },
      {
        id: "ndt05",
        databackgroundgradient: "linear-gradient(to bottom, #283325, #808080)",
        datatransition: "fade-in slide-out",
        content: `
          <div class="txt-stroke-black-shadow">We work with a wide range of technical devices groups:</div>
          <div class="r-stack txt-stroke-blue-shadow">
            <div class="fragment current-visible" style="widht:427px; height:428px; background-image:url(/img/presentation/lifting-beam-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:300px; width:428px; margin-left:30px; margin-right:30px;">Lifting mechanisms</p>
            </div>
            <div class="fragment current-visible" style="widht:400px; height:326px; background-image:url(/img/presentation/process-pipelines-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:340px; width:400px; margin-left:30px; margin-right:30px;">Process pipes</p>
            </div>
            <div class="fragment current-visible" style="widht:494px; height:278px; background-image:url(/img/presentation/vessels-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:300px; width:494px; margin-left:30px; margin-right:30px;">Vessels</p>
            </div>
            <div class="fragment current-visible" style="widht:591px; height:392px; background-image:url(/img/presentation/steel-structural-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:320px; width:591px; margin-left:30px; margin-right:30px;">Steel structures</p>
            </div>
            <div class="fragment current-visible" style="widht:500px; height:334px; background-image:url(/img/presentation/gas-pipework-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:340px; width:500px; margin-left:30px; margin-right:30px;">Heating networks and gas pipelines</p>
            </div>
            <div class="fragment current-visible" style="widht:605px; height:388px; background-image:url(/img/presentation/oil-storage-tanks-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:220px; width:605px; margin-left:30px; margin-right:30px;">Tanks</p>
            </div>
            <div class="fragment current-visible" style="widht:595px; height:419px; background-image:url(/img/presentation/arms-skoba-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:300px; width:595px; margin-left:30px; margin-right:30px;">Rebar butt joints</p>
            </div>
            <div class="fragment current-visible" style="widht:750px; height:485px; background-image:url(/img/presentation/pe-pipes.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:10px; width:750px; margin-left:30px; margin-right:30px;">Polymeric pipelines</p>
            </div>
            <div class="fragment current-visible" style="widht:717px; height:258px; background-image:url(/img/presentation/train-veels-01.jpg); align-items:center; background-blend-mode: multiply; background-position: center center; -webkit-background-size: cover;">
              <p style="margin-top:300px; width:717px; margin-left:30px; margin-right:30px;">And much more!</p>
            </div>
          </div>
        `
      },
      {
        id: "ndt06",
        databackground: "/img/presentation/sop.jpg",
        datatransition: "slide",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>For each technical devices group we have <span style="color:Wheat; font-weight:bold;">Special tuning sample for ultrasonic testing</span>,</p>
            <p class="fragment fade-up">as well as a variety of auxiliary equipment for other testing methods</p>
          </div>
        `
      },
      {
        id: "ndt07",
        databackground: "/img/presentation/rk-conclusion-01.jpg",
        datatransition: "slide",
        content: `
          <div class="txt-stroke-black-shadow-glow-white">
            <p class="fragment" style="font-size:0.7em; font-weight:bold; color:Aquamarine;">* Take a photo of this QR code:  </span><img src="/img/presentation/qr-01.jpg" /></span></p>
            <p class="" style="color:Cornflowerblue;">Our laboratory reports have a QR code that allows you to check the protocol authenticity, and in some cases, at the Customer or the Technical Supervision request, see <span style="color:Deeppink; font-weight:bold;">digital copy of x-rays-films</span></p>
          </div>
        `
      },
      {
        id: "mex01",
        databackground: "/img/presentation/hardness-testing.jpg",
        datatransition: "fade-in slide-out",
        databackgroundtransition: "convex",
        content: `
          <h3 class="txt-stroke-black-shadow">«Geocontrol-NN» Testing Laboratory</h3>
        `
      },
      {
        id: "mex02",
        databackground: "/img/presentation/templates-after-tests.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>The laboratory is well prepared for checking Test Welded Joints (Test-coupons),</p>
            <p class="fragment fade-up">permissive joints performed by welders at a construction site,</p>
            <p class="fragment fade-up">as well as assessment of Test-coupons during certification "NAKS" or Welding Process Certification.</p>
          </div>
        `
      },
      {
        id: "mex03",
        databackgroundvideo: "/img/presentation/cutting-templates.mp4",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow">We will cut the templates from the Test-coupon on our own equipment</p>
        `
      },
      {
        id: "mex04",
        databackground: "/img/presentation/grinding-templates.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow">Removing the weld bulge</p>
        `
      },
      {
        id: "mex05",
        databackgroundvideo: "/img/presentation/milling-templates.mp4",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow">Perform milling</p>
        `
      },
      {
        id: "mex06",
        databackgroundvideo: "/img/presentation/impact-bend.mp4",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow">We will conduct tests on our equipment</p>
          <p class="txt-stroke-black-shadow" style="font-size:0.7em; font-weight:bold; color:Aquamarine;">* possible at high or low temperatures</p>
        `
      },
      {
        id: "mex07",
        databackground: "/img/presentation/chemical-spectr-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>In addition to standard methods: Tension test, Static bending, Impact charpy test,</p>
            <p class="fragment fade-up">We will perform high-quality micrometallography (micro-structure-analise),</p>
            <p class="fragment fade-up">investigation of the metals or welding materials chemical composition</p>
          </div>
        `
      },
      {
        id: "mex08",
        databackground: "/img/presentation/flattering-02.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">We will perform tests pipe samples for flattening and bulging</p>
        `
      },
      {
        id: "mex09",
        databackground: "/img/presentation/coupling-reebar-connection-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Can test for tension coupling or welded joints of rebars with a diameter up to 50mm</p>
        `
      },
      {
        id: "mex10",
        databackground: "/img/presentation/pmi-02.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">We will quickly determine the metals (welds) chemical composition, check the compliance of the material grade with the project</p>
        `
      },
      {
        id: "mex11",
        databackground: "/img/presentation/big-kss.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">We can handle even large-thickness welding-samples</p>
        `
      },
      {
        id: "mex12",
        databackground: "/img/presentation/norma-winsteel-asme.png",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <div class="txt-stroke-black-shadow">
            <p>«Geocontrol-NN» has a license regulatory documents database - NormaCS</p>
            <p class="fragment fade-up">Also we have the licensed program WinSteel (all countries steel grades)</p>
            <p class="fragment fade-up">And a large foreign standards base (ASME, ASTM, API, ISO, DIN, AWS...)</p>
          </div>
        `
      },
      {
        id: "mex13",
        databackground: "/img/presentation/en-ru-protocol.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "fade",
        content: `
          <p class="txt-stroke-black-shadow" style="color:Wheat; font-weight:bold;">At the Customer request, we will provide Protocols in 2 languages: EN & RU</p>
        `
      },
      {
        id: "civillab01",
        databackground: "/img/presentation/civil-laboratory-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Huge area of the Laboratory accreditation - <span style="color:Wheat; font-weight:bold;">Testing building materials, asphalt, anti-corrosion coatings, waterproofing, concrete, bulk materials, plastics, soils...</span></p>
        `
      },
      {
        id: "civillab02",
        databackground: "/img/presentation/concrete-compression-01.jpg",
        dataautoanimate: true,
        content: `
        <div class="txt-stroke-black-shadow">
          <p data-id="txt04" style="margin-top:150px;">We can test concrete for strength not only in laboratory conditions,</p>
          <p data-id="txt05" style="display:none;">But also by field methods: spall separation, shock-pulse method, ultrasonic test</p>
        </div>
        `
      },
      {
        id: "civillab03",
        databackground: "/img/presentation/shock-pulse-method.jpg",
        dataautoanimate: true,
        content: `
        <div class="txt-stroke-black-shadow">
          <p data-id="txt04">We can test concrete for strength not only in laboratory conditions,</p>
          <p data-id="txt05">But also by field methods: spall separation, shock-pulse method, ultrasonic test</p>
        </div>
        `
      },
      {
        id: "civillab04",
        databackground: "/img/presentation/geomembranes-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">Without any problems we can test geomembranes, geotextiles, polymer geogrids, geodrenes</p>
        `
      },
      {
        id: "civillab05",
        databackground: "/img/presentation/sifting-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">We will analyze not only crushed stone and sand, but also any other bulk materials for granulometric composition</p>
        `
      },
      {
        id: "civillab06",
        databackground: "/img/presentation/soil-compaction-01.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">We will determine the maximum density and optimal humidity of the soil, sand-soil mixture, etc.</p>
        `
      },
      {
        id: "ic01",
        databackgroundvideo: "/img/presentation/hidrotest-valve-01.mp4",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">One of the significant laboratory areas - <span style="color:Wheat; font-weight:bold;">HYDRAULIC TESTING OF SHUT-OFF VALVES</span></p>
        `
      },
      {
        id: "ic02",
        databackground: "/img/presentation/pmi-valve-01.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">As well as incoming control of valves, fittings and other products of petrochemical construction</p>
        `
      },
      {
        id: "ic03",
        databackground: "/img/presentation/dpi-01.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">A wide range of laboratory testing capabilities allows us to effectively carry out incoming inspection of any products</p>
        `
      },
      {
        id: "ic04",
        databackground: "/img/presentation/ic-protocol-01.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">The most detailed protocol of incoming inspection</p>
        `
      },
      {
        id: "phwt01",
        databackgroundvideo: "/img/presentation/phwt-01.mp4",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow"><span style="color:Wheat; font-weight:bold;">HEAT TREATMENT OF WELDED JOINTS (PHWT)</span></p>
        `
      },
      {
        id: "phwt02",
        databackground: "/img/presentation/phwt-02.jpg",
        datatransition: "fade-in fade-out",
        databackgroundtransition: "convex",
        content: `
          <p class="txt-stroke-black-shadow">A large selection of heating mats allows us perform PHWT not for only butt welds, but also tee-cut-in-joints</p>
        `
      },
      {
        id: "phwt03",
        databackground: "/img/presentation/phwt-03.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">2 six-channel thermal posts allow to heat up to 12-18 welded joints simultaneously</p>
        `
      },
      {
        id: "phwt04",
        databackground: "/img/presentation/phwt-04.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">3 single-channel thermoposts add mobility and accessibility of joints at height</p>
        `
      },
      {
        id: "phwt05",
        databackground: "/img/presentation/phwt-05.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <div class="txt-stroke-black-shadow">
            <p class="">We move 6-channel posts together with auxiliary equipment in insulated trailers equipped with air conditioners and heaters,</p>
            <p class="txt-stroke-black-shadow fragment fade-up">which allows us to quickly mobilize to the site</p>
            <p class="txt-stroke-black-shadow fragment fade-up">and carry out heat treatment at any ambient temperature</p>
          </div>
        `
      },
      {
        id: "ellab01",
        databackgroundvideo: "/img/presentation/ellab-01.mp4",
        datatransition: "fade-in fade-out",
        content: `
          <p class="txt-stroke-black-shadow">NEW OUR DIRECTION - <span style="color:Wheat; font-weight:bold;">ELECTRICAL LABORATORY</span></p>
        `
      },
      {
        id: "ellab02",
        databackground: "/img/presentation/ellab-02.jpg",
        datatransition: "fade-in fade-out",
        content: `
          <div class="txt-stroke-black-shadow">
            <p class=""><span style="color:Wheat; font-weight:bold;">Our Electro-Laboratory possibilities:</span></p>
            <ul style="font-size:0.8em; list-style-image:url(img/listmarkers/marker08.png)">
              <li class="fragment fade-up">Measurement of cable insulation electrical resistance</li>
              <li class="fragment fade-up">Measurement of ground-line resistance (efficiency, presence of a circuit between earthed installations)</li>
              <li class="fragment fade-up">Checking the lightning protection system</li>
              <li class="fragment fade-up">Checking the impedance of the «phase-zero» loop</li>
              <li class="fragment fade-up">Checking the circuit breakers tripping</li>
              <li class="fragment fade-up">Inspection and testing of circuit breakers controlled by residual current (RCD)</li>
              <li class="fragment fade-up">Thermal imaging control of input and switchboards / devices</li>
            </ul>
          </div>
        `
      },
      {
        id: "whyus01",
        databackground: "/img/presentation/lyapaev-class.jpg",
        databackgroundtransition: "slide",
        content: `
          <div class="txt-stroke-black-shadow">
            <p style="color:Wheat; font-weight:bold;">Our advantages:</p>
            <ul style="font-size:0.8em; list-style-image: url(img/listmarkers/marker05w.png)">
              <li class="">Low prices <a href="/price/Price_GC_2023-2024_NK_MEX_STROY.pdf" download="Price_GC_2023-2024_NK_MEX_STROY.pdf">(💾 Download GC-Price for 2023-2024)</a></li>
              <li class="fragment fade-up">Technically competent staff, they are professionals in their field!</li>
              <li class="fragment fade-up">Mobility and quick departure to the facility</li>
              <li class="fragment fade-up">Modern equipment</li>
              <li class="fragment fade-up">We work in accordance with the current regulatory requirements</li>
              <li class="fragment fade-up">Protocols tailored to your requirements (possible in 2 languages: RU/EN)</li>
            </ul>
          </div>
        `
      },
      {
        id: "whyus02",
        databackground: "/img/presentation/automating-01.jpg",
        databackgroundtransition: "convex",
        content: `
          <div class="txt-stroke-black-shadow">
            <p style="color:Aquamarine; font-weight:bold;">Among other things:</p>
            <ul style="font-size:0.8em; list-style-image: url(img/listmarkers/marker05w.png)">
              <li class="">Only we have a high degree work automation (electronic document management and electronic conclusions journal)</li>
              <li class="fragment fade-up">At the Customers request, we provide access to a personal account on the website, where you can track the test results in real time</li>
            </ul>
          </div>
        `
      },
      {
        id: "whyus03",
        databackgroundvideo: "/img/presentation/online-journal.mp4",
        datatransition: "fade-in fade-out",
        content: ``
      },
      {
        id: "geography",
        iframe: "/geography",
        databackgroundcolor: "rgba(20, 20, 20, 100)",
        datatransition: "fade-in fade-out",
        content: ``
      },
      {
        id: "theend",
        content: `<h2>Thanks for your attention!</h2><br>
            <p>Contact phone: 8-800-505-65-45</p>
            <p><small><a href="https://www.gc-nn.com">Back to the main site - GC-NN.COM</a></small></p>`
      }
    ],
    centerMap: [58.010400, 56.229486], zoomMap: 5,
    ourObjects: [
      {
        centerLabel: [56.238242, 43.461571],
        iconLayout: "default#image", /* preset: "islands#greenStretchyIcon", */
        iconImageHref: "/img/presentation/labels/sibur.png",
        hintContent: "Sibur-Dzerzhinsk, Sibur-Kstovo" /* balloonContent: "" */
      },
      {
        centerLabel: [58.236834, 68.438199],
        iconLayout: "default#image", /* preset: "islands#greenStretchyIcon", */
        iconImageHref: "/img/presentation/labels/sibur.png",
        hintContent: "Sibur-Tobolsk" /* balloonContent: "" */
      },
      {
        centerLabel: [56.150622, 44.206753],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/lukoil.png",
        hintContent: "LUKOIL-Kstovo"
      },
      {
        centerLabel: [57.918517, 56.143750],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/lukoil.png",
        hintContent: "LUKOIL-Perm"
      },
      {
        centerLabel: [55.644033, 37.802694],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/gazprom.png",
        hintContent: "MNPZ. Gazprom-Neft"
      },
      {
        centerLabel: [54.131784, 36.484640],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/gazprom.png",
        hintContent: "Cherepetskaya GRES"
      },
      {
        centerLabel: [51.237431, 47.514839],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/gazprom.png",
        hintContent: "Gazprom. Mokrous"
      },
      {
        centerLabel: [53.543499, 49.607079],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/toaz.png",
        hintContent: "TogliattiAzot"
      },
      {
        centerLabel: [51.926912, 47.909097],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/phosagro.png",
        hintContent: "Phosagro. Balakovo branch of JSC 'APATIT'"
      },
      {
        centerLabel: [59.919308, 32.351911],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/phosagro.png",
        hintContent: "Phosagro. Volkhov branch of JSC 'APATIT'"
      },
      {
        centerLabel: [67.610946, 33.696134],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/phosagro.png",
        hintContent: "Kirov branch of JSC 'APATIT'"
      },
      {
        centerLabel: [59.883712, 30.178655],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/pnt.png",
        hintContent: "Petersburg Oil Terminal"
      },
      {
        centerLabel: [59.108405, 37.971972],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/mostostroy.png",
        hintContent: "Mostostroy. Bridge over the Sheksna River"
      },
      {
        centerLabel: [65.975364, 78.345158],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/mostostroy.png",
        hintContent: "Mostostroy. Bridge over the river Pur"
      },
      {
        centerLabel: [69.355657, 88.142020],
        iconLayout: "default#image", iconImageHref: "/img/presentation/labels/nornikel.png",
        hintContent: "Nornickel. Plant 'Nadezhdinskiy', plant 'Medny'"
      }
    ]
  }
};
/* eslint-enable max-len */
